/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Region_RequiredInputs */

const en_us2_profile_editors_pain_region_required = /** @type {(inputs: Profile_Editors_Pain_Region_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick where it hurts.`)
};

const pt_br2_profile_editors_pain_region_required = /** @type {(inputs: Profile_Editors_Pain_Region_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha onde dói.`)
};

const es_419_profile_editors_pain_region_required = /** @type {(inputs: Profile_Editors_Pain_Region_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige dónde duele.`)
};

const pt_pt2_profile_editors_pain_region_required = /** @type {(inputs: Profile_Editors_Pain_Region_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe onde dói.`)
};

const fr_fr2_profile_editors_pain_region_required = /** @type {(inputs: Profile_Editors_Pain_Region_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis où tu as mal.`)
};

const de_de2_profile_editors_pain_region_required = /** @type {(inputs: Profile_Editors_Pain_Region_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl, wo es wehtut.`)
};

const it_it2_profile_editors_pain_region_required = /** @type {(inputs: Profile_Editors_Pain_Region_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli dove fa male.`)
};

/**
* | output |
* | --- |
* | "Pick where it hurts." |
*
* @param {Profile_Editors_Pain_Region_RequiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_region_required = /** @type {((inputs?: Profile_Editors_Pain_Region_RequiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Region_RequiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_region_required(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_region_required(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_region_required(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_region_required(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_region_required(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_region_required(inputs)
	return en_us2_profile_editors_pain_region_required(inputs)
});
export { profile_editors_pain_region_required as "profile-editors.pain_region_required" }